import { FinanceAccountMoveMoneySummaryContainer } from '../../../../containers';

export const FinanceAccountMoveMoneySummary = () => {
  return <FinanceAccountMoveMoneySummaryContainer />;
};
